<template lang="pug">
    nav.nav
        router-link.navItem(
            v-if="item.access.includes(role) && allowedToShow(item)"
            v-for="(item, key) in navItems"
            :key="`${item.title}-${key}`"
            :to="item.url"
        )
            v-icon.navItemIcon {{ isMobile ? item.icon : 'keyboard_arrow_right' }}
            div.navItemText {{ isMobile ? item.titleMobile : item.title }}
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters('auth', ['role', 'status']),

            navItems() {
                return this.$t('profile.navigation');
            },
            /**
             * Check screen resolution
             */
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        methods: {
            allowedToShow(item) {
                if (!item.status) return true;
                return item.status.includes(this.status);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .nav .navItem:first-child
        padding: 0 0 15px

    .navItem
        display: flex
        align-items: center
        padding: 15px 0
        text-decoration: none
        border-bottom: 1px solid rgba($theme.sidebar, 0.5)

        &:hover
        &.router-link-exact-active
            cursor: pointer

            .navItemIcon
                opacity: 1
                color: $theme.action

    .navItemIcon
        color: $theme.sidebar
        opacity: 0.5
        transition: opacity 0.3s

    .navItemText
        color: $theme.white
        font-size: 15px
        font-weight: 700

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .nav
            display: flex
            align-items: center

            & .navItem:first-child
                padding 5px 0

        .navItem
            flex: 1 1 25%
            height: 100%
            padding 5px 0
            flex-direction: column
            text-align: center

        .navItemText
            font-size: 10px
            font-weight: 500
</style>
